import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchVideos } from "../services/videoGalleryService";

export const fetchVideoGalleryThunk = createAsyncThunk(
  "videoGallery/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchVideos();
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue("Failed to load gallery");
    }
  }
);

const initialState = {
  videos: [],
  status: "idle", // idle | loading | succeeded | failed
  error: null,
};

const videoGallerySlice = createSlice({
  name: "videoGallery",
  initialState,
  reducers: {
    resetVideoGallery: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideoGalleryThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVideoGalleryThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.videos = action.payload.map((v) => ({
          ...v,
          height: v.height ?? Math.floor(Math.random() * 80) + 320,
        }));
      })
      .addCase(fetchVideoGalleryThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetVideoGallery } = videoGallerySlice.actions;
export default videoGallerySlice.reducer;
